import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import {
    CampaignReport,
    DashboardFilterOptions,
    DashboardIdle,
    DashboardSummary,
    ForecastReport,
    FunnelReport,
} from './responses/dashboard.response';

type Query = Record<string, string>;

export class DashboardService extends BaseService {
    protected get resourceName(): string {
        return 'crm/dashboard';
    }

    public async summary(query: Query): Promise<AxiosResponse<{ data: DashboardSummary }>> {
        return await this.get('summary', query);
    }

    public async idle(query: Query): Promise<AxiosResponse<{ data: DashboardIdle }>> {
        return await this.get('idle', query);
    }

    public async funnel(query: Query): Promise<AxiosResponse<{ data: FunnelReport }>> {
        return await this.get('funnel', query);
    }

    public async forecast(query: Query): Promise<AxiosResponse<{ data: ForecastReport }>> {
        return await this.get('forecast', query);
    }

    public async filters(): Promise<AxiosResponse<{ data: DashboardFilterOptions }>> {
        return await this.get('filters');
    }

    public async campaigns(
        from: string,
        to: string
    ): Promise<AxiosResponse<{ data: CampaignReport }>> {
        return await this.get('campaigns', { from, to });
    }
}
